import { useSelector } from 'react-redux';
import { getBreadcrumbs } from 'selectors';
import { useSelectorProps } from './useSelectorProps';
export var useBreadcrumbs = function useBreadcrumbs() {
  var defaultBreadcrumbs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectorProps = useSelectorProps();

  var _useSelector = useSelector(function (state) {
    return getBreadcrumbs(state, selectorProps);
  }),
      breadcrumbs = _useSelector.items;

  if (!breadcrumbs) return defaultBreadcrumbs; // breadcrumbs returned from API may not contain all items, because SEO engineer
  // is not entered all data yet. In such a case we need to use a default.

  if (defaultBreadcrumbs.length > breadcrumbs.length) {
    return breadcrumbs.concat(defaultBreadcrumbs.slice(breadcrumbs.length));
  }

  return breadcrumbs;
};
export default useBreadcrumbs;